import { createFileRoute } from "@tanstack/react-router";
import AcceleratedTmsFiveDayWeek from "@/pages/AcceleratedTmsFiveDayWeek";
export const Route = createFileRoute("/accelerated-tms-five-day-week")({
  component: RouteComponent,
  head() {
    return {
      meta: [
        {
          title:
            "What the SAINT® Five-Day Treatment Week Is Like | Neuro Wellness TMS",
        },
        {
          name: "description",
          content:
            "A 5-day accelerated TMS week compresses weeks of treatment into days. Learn how SAINT TMS scheduling works in Coral Springs, FL Free consultation available.",
        },
        {
          property: "og:title",
          content:
            "What the SAINT® Five-Day Treatment Week Is Like | Neuro Wellness TMS",
        },
        {
          property: "og:description",
          content:
            "A 5-day accelerated TMS week compresses weeks of treatment into days. Learn how SAINT TMS scheduling works in Coral Springs, FL Free consultation available.",
        },
        {
          property: "og:url",
          content: "https://neurowellnesstms.com/accelerated-tms-five-day-week",
        },
        {
          property: "og:type",
          content: "website",
        },
        {
          name: "twitter:card",
          content: "summary_large_image",
        },
      ],
      links: [
        {
          rel: "canonical",
          href: "https://neurowellnesstms.com/accelerated-tms-five-day-week",
        },
      ],
    };
  },
});
function RouteComponent() {
  return <AcceleratedTmsFiveDayWeek />;
}
